/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    content: z.any(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    content: z.any(),
}
).strict();
const relationSchema = z.object({
    comment: z.record(z.string(), z.unknown()),
    user: z.record(z.string(), z.unknown()),
    files: z.array(z.unknown()).optional(),
}
);
const fkSchema = z.object({
    commentId: z.string(),
    userId: z.string(),
}
);

/**
 * `Reply` schema excluding foreign keys and relations.
 */
export const ReplyScalarSchema = baseSchema;


/**
 * `Reply` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const ReplySchema = ReplyScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const ReplyPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const ReplyPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    content: z.any()
}).partial().passthrough();


/**
 * `Reply` schema for create operations excluding foreign keys and relations.
 */
export const ReplyCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true
});


/**
 * `Reply` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const ReplyCreateSchema = ReplyCreateScalarSchema.merge(fkSchema);


/**
 * `Reply` schema for update operations excluding foreign keys and relations.
 */
export const ReplyUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `Reply` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const ReplyUpdateSchema = ReplyUpdateScalarSchema.merge(fkSchema.partial());

